import {Howl} from "howler";

const bgMusic = () => {
    const sound = new Howl({
        src: ['../src/assets/music/background.mp3'],
        onplayerror: function() {
            sound.once('unlock', function() {
                sound.play();
            });
        }
    });

    sound.volume(.3)
    sound.loop(true)

    return sound;
}

const clickMusic = () => {
    const sound = new Howl({
        src: ['../src/assets/music/click.wav'],
    });
    sound.volume(1)

    return sound
}

const scratchMusic = () => {
    const sound = new Howl({
        src: ['../src/assets/music/scratch.wav'],
    });
    sound.volume(1)

    return sound
}

const openCardsMusic = () => {
    const sound = new Howl({
        src: ['../src/assets/music/open_cards.wav'],
    });
    sound.volume(1)

    return sound
}

const loseMusic = () => {
    const sound = new Howl({
        src: ['../src/assets/music/lose.wav'],
    });
    sound.volume(1)

    return sound
}

const winMusic = () => {
    const sound = new Howl({
        src: ['../src/assets/music/win.wav'],
    });
    sound.volume(1)

    return sound
}


export {
    bgMusic,
    clickMusic,
    scratchMusic,
    openCardsMusic,
    loseMusic,
    winMusic
}